// The dossier's pages, grouped as the sidebar shows them. The command
// palette searches the same list, so both always offer the same places.
import { Activity, BookOpen, CalendarClock, ClipboardCheck, ClipboardList, FileText, FolderOpen, History, LayoutDashboard,
  Library, ListChecks, Network, Table2, UserCog, Users, type LucideIcon } from "lucide-react";

export interface NavPage {
  /** Relative to the dossier ("" is its dashboard). */
  path: string;
  label: string;
  Icon: LucideIcon;
  end?: boolean;
  adminOnly?: boolean;
}

export const NAV_GROUPS: { title: string; pages: NavPage[] }[] = [
  { title: "nav.overview", pages: [{ path: "", label: "nav.dashboard", Icon: LayoutDashboard, end: true }] },
  { title: "nav.dossier", pages: [
    { path: "documents", label: "nav.documents", Icon: FolderOpen },
    { path: "readiness", label: "nav.readiness", Icon: ListChecks },
    { path: "datapoints", label: "nav.datapoints", Icon: Table2 },
    { path: "plan", label: "nav.plan", Icon: Network },
    { path: "team", label: "nav.team", Icon: Users },
    { path: "planning", label: "nav.planning", Icon: CalendarClock },
  ] },
  { title: "nav.sfcr", pages: [{ path: "synthese", label: "nav.synthesis", Icon: BookOpen }] },
  { title: "nav.review", pages: [
    { path: "issues", label: "nav.issues", Icon: ClipboardList },
    { path: "audits", label: "nav.audits", Icon: ClipboardCheck },
  ] },
  { title: "nav.output", pages: [{ path: "report", label: "nav.report", Icon: FileText }] },
  { title: "nav.system", pages: [
    { path: "history", label: "nav.history", Icon: Activity },
    { path: "audit", label: "nav.audit", Icon: History },
    { path: "referentiel", label: "nav.referential", Icon: Library },
    { path: "users", label: "nav.users", Icon: UserCog, adminOnly: true },
  ] },
];

export function pagePath(dossierId: string, path: string): string {
  return path ? `/dossiers/${dossierId}/${path}` : `/dossiers/${dossierId}`;
}

/** "⌘K" on Apple keyboards, "Ctrl K" elsewhere. */
export function shortcutLabel(key: string): string {
  return typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.userAgent) ? `⌘${key}` : `Ctrl ${key}`;
}

export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  return (words.length > 1 ? words[0][0] + words[1][0] : (words[0] || "?").slice(0, 2)).toUpperCase();
}
